import { render, staticRenderFns } from "./HowItWorkRight.vue?vue&type=template&id=08679c67&scoped=true&"
import script from "./HowItWorkRight.vue?vue&type=script&lang=js&"
export * from "./HowItWorkRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08679c67",
  null
  
)

export default component.exports